export default __webpack_public_path__ + "superscript-text-formatting.png";